<div class="flex items-center text-left">
  <ng-container *ngIf="params.node.group && params.value; else aggResultTmpl">
    <button (click)="toggleOpen()" mat-icon-button class="small-icon-button mr-1">
      <fa-icon
        [icon]="['fal', params.node.expanded ? 'chevron-down' : 'chevron-right']"
        class="fs-08 text-gray-600"
      ></fa-icon>
    </button>
    <img *ngIf="icon" [width]="18" [src]="icon" alt="" class="type-icon mr-1" />
    <span *ngIf="params.node.level === 0" class="truncate" [matTooltip]="(name | titlecase) || ''">
      {{ name | titlecase }}
    </span>
    <span *ngIf="params.node.level > 0" class="truncate" [matTooltip]="params.value || name || ''">
      {{ params.value || name }}
    </span>
  </ng-container>
  <ng-template #aggResultTmpl>
    <ng-container *ngIf="!params.node.group">
      <img *ngIf="icon" [width]="18" [src]="icon" alt="" class="type-icon mr-1" />
      <span *ngIf="!params.node.group" class="truncate" [matTooltip]="(params.value | titlecase) || ''">
        {{ params.value | titlecase }}
      </span>
    </ng-container>
    <span *ngIf="params.node.group && aggregationResult as value" class="truncate" [matTooltip]="value">
      {{ value }}
    </span>
  </ng-template>
</div>
